module.exports = __webpack_public_path__ + "static/media/29BDOS20.234ff61d.jpg";